export const CART_ADD_ITEM = 'cart/ADD_ITEM';
export const CART_REMOVE_ITEM = 'cart/REMOVE_ITEM';
export const CART_UPDATE_QUANTITY = 'cart/UPDATE_QUANTITY';
export const CART_CLEAR = 'cart/CLEAR';
export const CART_REPLACE_ITEMS = 'cart/REPLACE_ITEMS';
